import Quill from "quill";

const EDITOR_SELECTOR = ".js-message-reply-editor, .js-message-editor, .js-help-answer-editor";

const toolbar = [
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["blockquote", "link"],
  ["clean"],
];

function isBlank(editor) {
  return editor.getText().trim() === "";
}

function initializeEditor(element) {
  if (!(element instanceof HTMLElement) || element.dataset.quillInitialized === "1") {
    return;
  }

  const textareaId = element.dataset.textareaId;
  const textarea = textareaId ? document.getElementById(textareaId) : null;
  const form = element.closest("form");

  if (!(textarea instanceof HTMLTextAreaElement) || !(form instanceof HTMLFormElement)) {
    return;
  }

  const isHelpEditor = element.matches(".js-help-answer-editor");
  const editor = new Quill(element, {
    // Match the FAQ sanitizer before posting, including content pasted from Word.
    ...(isHelpEditor ? { formats: ["bold", "italic", "underline", "strike", "list", "blockquote", "link", "code"] } : {}),
    modules: { toolbar: isHelpEditor ? [...toolbar, ["code"]] : toolbar },
    placeholder: element.dataset.placeholder || "Napisz odpowiedź...",
    theme: "snow",
  });

  if (element.dataset.labelId) {
    editor.root.setAttribute("aria-labelledby", element.dataset.labelId);
    editor.root.setAttribute("role", "textbox");
    editor.root.setAttribute("aria-multiline", "true");
    editor.root.setAttribute("aria-required", "true");
  }

  if (textarea.value.trim() !== "") {
    editor.clipboard.dangerouslyPasteHTML(textarea.value);
  }

  if (element.dataset.disabled === "true") {
    editor.enable(false);
  }

  const syncValue = () => {
    // Quill exports empty blocks without a break, so sanitization removes the blank line.
    textarea.value = isBlank(editor) ? "" : editor.getSemanticHTML().replace(/<(p|blockquote)><\/\1>/g, "<$1><br></$1>");
  };

  if (element.dataset.disabled !== "true") {
    editor.on("text-change", syncValue);
    form.addEventListener("submit", syncValue);
  }
  element.dataset.quillInitialized = "1";
}

export function initMessageReplyEditors(root = document) {
  if (!(root instanceof Document || root instanceof Element)) {
    return;
  }

  const editors = root instanceof Element && root.matches(EDITOR_SELECTOR) ? [root] : [];
  editors.push(...root.querySelectorAll(EDITOR_SELECTOR));
  editors.forEach(initializeEditor);
}
